export const COMMON_I18N_PREFIX = "features.home.components.common";

export const COMMON_I18N_KEYS = {
  see_more: "see_more",
  see_less: "see_less",
  contact_us: "contact_us",
  add_topic: "add_topic",
  load_more: "load_more",
  no_articles_title: "no_articles_title",
  its_empty_title: "its_empty_title"
}


// WEBPACK FOOTER //
// ./src/features/home/components/constants/i18n/Commoni18nConstants.js